import React from 'react';
import { Layout, Tabs } from 'antd';
import GeneralSettings from './GeneralSettings';
import ClientSetup from './ClientSetup';
import ClientSettings from './ClientSettings';
import Guidelines from './Guidelines';
import Glossaries from './Glossaries';
import Memories from './Memories';
import UploadMemories from './UploadMemories';

const { Header, Content } = Layout;
const { TabPane } = Tabs;

const Settings = () => {
  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Layout>
        <Content
          style={{
            background: '#fff',
            padding: 24,
            margin: 0,
            minHeight: 280,
          }}
        >
          <Tabs defaultActiveKey="1">
            <TabPane tab="Manage Clients" key="1">
              <ClientSetup />
            </TabPane>
            <TabPane tab="Clients settings" key="3">
              <ClientSettings />
            </TabPane>
            <TabPane tab="Manage Guidelines" key="4">
              <Guidelines />
            </TabPane>
            <TabPane tab="Manage Glossaries" key="5">
              <Glossaries />
            </TabPane>
            <TabPane tab="Manage Memories" key="6">
              <Memories />
            </TabPane>
            <TabPane tab="Upload Memories" key="10">
              <UploadMemories />
            </TabPane>            
            <TabPane tab="Other Settings" key="9">
              <GeneralSettings />
            </TabPane>


          </Tabs>
        </Content>
      </Layout>
    </Layout>
  );
};

export default Settings;
